var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-wrapper"},[_c('v-icon',{staticClass:"dot",staticStyle:{"font-size":"48px"},attrs:{"color":"#cc3d3f"},on:{"click":function($event){return _vm.jumpSection('landing')}}},[_vm._v("mdi-arrow-up-circle-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }